<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-xs-12 videoPainel bg-white p-3 shadow_bar">
        <div class="row">
          <div class="col-lg-12 col-xs-12">
            <h3
              style="color: #000"
              class="center"
            >Responda as perguntas:</h3>
          </div>
          <div class="col-lg-12 col-xs-12">
            <div
              v-for="(question, index) in job_questions"
              :key="question.id"
            >
              <div v-if="index == question_show">
                <div
                  class="f18"
                  style="color: #000 !important"
                  v-html="question.title"
                ></div>
                <div class="d-flex justify-content-center">
                  <p
                    class="text-justify text-break"
                    style="width: 70%; text-align: center !important"
                  >
                    {{ question.details }}
                  </p>
                </div>
                <div
                  class="videoPlay"
                  v-if="question.video_id"
                >
                  <video
                    class="full"
                    controls
                    controlslist="nodownload"
                    playsinlineatributo
                    preload="yes"
                    v-if="question.video_id"
                  >
                    <source
                      :src="question.video"
                      type="video/mp4"
                    />
                  </video>
                  <p>ASSISTA O VÍDEO E RESPONSA</p>
                </div>
                <div
                  class="videoPlay"
                  v-if="question.response_type == video_type"
                >
                  <div
                    class="center"
                    v-show="error"
                    style="color: #000"
                  >
                    <p>
                      <b>NÃO FOI POSSÍVEL ABRIR A CÂMERA</b>
                    </p>
                    <p class="f16">
                      TENTE GRAVAR USANDO DIRETO AS CÂMERAS DE SEU CELULAR OU
                      FAZER UPLOAD DO SEU VÍDEO, CLICANDO NO BOTÃO A BAIXO
                    </p>
                  </div>
                  <VideoJSRecordMobile
                    :question="question"
                    :index="index"
                    :currentTime="currentTime"
                    v-if="ios"
                  />
                  <VideoJSRecord
                    :question="question"
                    :index="index"
                    :currentTime="currentTime"
                    v-if="!ios"
                  />
                </div>
                <div v-if="question.response_type == multiple_choices_type">
                  <MultipleChoices
                    :question="question"
                    :index="index"
                    :currentTime="currentTime"
                    :answers="answers"
                    @saveAnswers="saveAnswer"
                  />
                </div>
                <div v-if="question.response_type == yer_or_no_type">
                  <YesOrNo
                    :question="question"
                    :index="index"
                    :currentTime="currentTime"
                    :answers="answers"
                    @saveAnswers="saveAnswer"
                  />
                </div>
                <div v-if="question.response_type == text_type">
                  <TextType
                    :question="question"
                    :index="index"
                    :currentTime="currentTime"
                    :answers="answers"
                    @saveAnswers="saveAnswer"
                  />
                </div>
                <div v-if="question.response_type == monetary_type">
                  <MonetaryType
                    :question="question"
                    :index="index"
                    :currentTime="currentTime"
                    :answers="answers"
                    @saveAnswers="saveAnswer"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-xs-12">
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-4 col-xs-12" />
          <div class="col-lg-4 col-xs-12">
            <transition name="fade">
              <button
                v-if="question_show > 0"
                @click="previousQuestion"
                class="btn btn-primary full"
              >
                Voltar
              </button>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoJSRecord from "components/VideoJSRecord.vue";
import VideoJSRecordMobile from "components/VideoJSRecordMobile.vue";
import MultipleChoices from "./MultipleChoices.vue";
import YesOrNo from "./YesOrNo.vue";
import TextType from "./TextType.vue";
import MonetaryType from "./MonetaryType.vue";

import {
  isMobile,
  mobileModel,
  osName,
  isChrome,
  isSafari,
  mobileVendor,
} from "mobile-device-detect";
export default {
  props: ["job_questions", "isIOS", "selective_process_uid"],
  components: {
    VideoJSRecord,
    VideoJSRecordMobile,
    MultipleChoices,
    YesOrNo,
    TextType,
    MonetaryType,
  },
  name: "Questions",
  data: () => ({
    question_show: 0,
    error: false,
    ios: false,
    timer: 0,
    currentTime: 0,
    video_type: 0,
    text_type: 1,
    multiple_choices_type: 2,
    yer_or_no_type: 3,
    monetary_type: 4,
    answers: [],
  }),
  mounted() {
    if (mobileModel == "iPhone") {
      this.ios = true;
    }

    if (
      (isMobile || mobileVendor == "Apple" || mobileVendor == "none") &&
      isSafari
    ) {
      this.ios = true;
    }

    if (isMobile && osName == "Android" && !isChrome) {
      this.ios = true;
    }

    eventBus.$on("nextQuestion", (index) => {
      this.question_show = index + 1;
      this.stopTimer();
      this.startTimer();
      this.finalScreen();
    });

    axios
      .get(`/candidates/answers/last_position/${this.selective_process_uid}`)
      .then((response) => {
        this.question_show = response.data.position;
        this.startTimer();
        this.finalScreen();
      });

    eventBus.$on("errorCam", (response) => {
      this.ios = true;
      this.error = true;
    });
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime += 1;
      }, 1000);
    },
    stopTimer() {
      window.clearInterval(this.timer);
      this.currentTime = 0;
    },
    finalScreen() {
      if (this.question_show >= this.job_questions.length) {
        this.stopTimer();
        eventBus.$emit("finalScreen", { status: true });
      }
    },
    previousQuestion() {
      this.question_show = this.question_show - 1;
      this.stopTimer();
      this.startTimer();
      this.finalScreen();
    },
    truncate(title) {
      return title.length > 50
        ? title.slice(0, 50).trim().concat("...")
        : title;
    },
    saveAnswer(answers) {
      if (this.answers[this.question_show]) {
        this.answers[this.question_show] = answers;
      } else {
        this.answers.push(answers);
      }
    }
  },
};
</script>